<template>
  <div v-if="refundDetail">
    <!-- <b-alert
      variant="danger"
      :show="refundDetail === null"
      v-if="!refundDetail"
    >
      <h4 class="alert-heading">
        Error fetching Refund Request Detail
      </h4>
      <div class="alert-body">
        <b-link class="alert-link" :to="{ name: 'refunds-request' }">
          <feather-icon icon="ArrowLeftIcon" /> Go Back to List
        </b-link>
        to Refund Request And Try again.
      </div>
    </b-alert> -->
    <div class="mb-1">
      <b-link :to="{ name: 'refunds-request' }">
        <feather-icon icon="ArrowLeftIcon" />
        <span class="align-middle">Back to List</span>
      </b-link>
    </div>

    <h3>Refund Request Detail</h3>
    <b-card>
      <b-card-header>
        <u><h5>Customer Information</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            Customer First Name:
            <strong>{{ refundDetail.firstName }}</strong>
          </b-form-group>
          <b-form-group>
            Customer Last Name:
            <strong>{{ refundDetail.lastName }} </strong>
          </b-form-group>
          <b-form-group>
            Customer Phone:
            <strong>{{ refundDetail.phone }} </strong>
          </b-form-group>
          <b-form-group>
            Customer Email:
            <strong>{{ refundDetail.email }} </strong>
          </b-form-group>
        </b-col></b-row
      >
    </b-card>

    <b-card>
      <b-card-header>
        <u><h5>Order Information</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            <strong>Custom Order Code: </strong>
            <span>{{ refundDetail.customOrderCode }}</span>
          </b-form-group>
          <b-form-group>
            <strong>FlyGate Order Id</strong>:
            <span>{{ refundDetail.flyGateOrderId }}</span>
          </b-form-group>

          <b-form-group>
            <strong>Amount: </strong>
            <span>{{ refundDetail.orderAmount }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Currency: </strong>
            <span>{{ refundDetail.currency }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Order Date: </strong>
            <span>{{ refundDetail.orderDateString }}</span>
          </b-form-group>
        </b-col>
      </b-row></b-card
    >

    <b-card>
      <b-card-header>
        <u><h5>Payment Detail</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            <strong>Paid Payment Option: </strong>
            <span>{{ refundDetail.paidFOP }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Vendor Txn RefNumber: </strong>
            <span>{{ refundDetail.vendorTxnRefNumber }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Paid Date: </strong>
            <span>{{ refundDetail.paidDate }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Paid Account Number: </strong>
            <span>{{
              refundDetail.paidAccountNumber
                ? refundDetail.paidAccountNumber.replace(
                    /(?<=^\d)\d+(?=\d{4}$)/,
                    "****",
                  )
                : ""
            }}</span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-card>
      <b-card-header>
        <u><h5>Refund Request Detail</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            <strong>Refund Requested Date: </strong>
            <span>{{ refundDetail.refundRequestedDateTime }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Refund Reference Code: </strong>
            <span>{{ refundDetail.refundReferenceCode }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Refund Merchant Request Code: </strong>
            <span>{{ refundDetail.refundMerchantRequestCode }}</span>
          </b-form-group>
          <b-form-group>
            <strong> Refund Requested Amount: </strong>
            <span>{{ refundDetail.refundRequestedAmount }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Original Ticket Number: </strong>
            <span>{{ refundDetail.originalTicketNumber }}</span>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <strong>Refund Document Number: </strong>
            <span>{{ refundDetail.refundDocumentNumber }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Refund Account Number: </strong>
            <span>{{
              refundDetail.refundAccountNumber
                ? refundDetail.refundAccountNumber.replace(
                    /(?<=^\d)\d+(?=\d{4}$)/,
                    "****",
                  )
                : ""
            }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Refund FOP: </strong>
            <span v-if="refundDetail.refundFOP">{{
              refundPaymentOptions.filter(
                (item) => item.value == refundDetail.refundFOP,
              )[0].text
            }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Refunded Date: </strong>
            <span>{{ refundDetail.refundedDateString }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Bank Refund Reference: </strong>
            <span>{{ refundDetail.refundReferenceCodeFromBank }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Refund Status: </strong>
            <span>
              <b-badge
                v-if="refundDetail.refundStatus === 0"
                pill
                variant="info"
                class="text-white"
              >
                Not Requested
              </b-badge>

              <b-badge
                v-else-if="refundDetail.refundStatus === 1"
                pill
                variant="warning"
                class="text-white"
              >
                Pending
              </b-badge>
              <b-badge
                v-else-if="refundDetail.refundStatus === 2"
                pill
                variant="light-success"
                class="text-white"
              >
                Submitted
              </b-badge>
              <b-badge
                v-else-if="refundDetail.refundStatus === 3"
                pill
                variant="success"
                class="text-white"
              >
                Request Approved
              </b-badge>
              <b-badge
                v-else-if="refundDetail.refundStatus === 4"
                pill
                variant="light-info"
                class="text-white"
              >
                Sent
              </b-badge>
              <b-badge
                v-else-if="refundDetail.refundStatus === 5"
                pill
                variant="danger"
                class="text-white"
              >
                Request Rejected
              </b-badge>
              <b-badge
                v-else-if="refundDetail.refundStatus === 6"
                pill
                variant="primary"
                class="text-white"
              >
                Completed
              </b-badge>
              <b-badge
                v-else-if="refundDetail.refundStatus === 8"
                pill
                variant="light-danger"
                class="text-white"
              >
                Cancelled
              </b-badge>
              <b-badge v-else pill variant="info">
                {{ refundDetail.refundStatus }}
              </b-badge>
            </span>
          </b-form-group>
          <b-form-group>
            <strong>Refund To Separate Account: </strong>
            <span>{{ refundDetail.refundToSeparateAccount }}</span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-card>
      <b-card-header>
        <u><h5>Workflow Approval Detail</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            <strong>Refund Workflow Current Level: </strong>
            <span>{{ refundDetail.refundWorkflowCurrentLevel }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Refund Approver UserId: </strong>
            <span>{{ refundDetail.refundApproverUserId }}</span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-card>
      <b-card-header>
        <u><h5>System Notification Response</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            <strong>Is Email Sent: </strong>
            <span>{{ refundDetail.isEmailSent }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Is Notify To Bank: </strong>
            <span>{{ refundDetail.isNotifyToBank }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Bank Notify Remark: </strong>
            <span>{{ refundDetail.refundNotifyRemark }}</span>
          </b-form-group>
          <b-form-group>
            <strong> Is Notified to merchants: </strong>
            <span>{{ refundDetail.isNotify }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Notify Remark: </strong>
            <span>{{ refundDetail.refundRemark }}</span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BCardBody,
  BCardHeader,
  BOverlay,
  BLink,
  BBadge,
} from "bootstrap-vue";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BCardBody,
    BCardHeader,
    BOverlay,
    BLink,
    BBadge,
  },
  data() {
    return {
      refundDetail: null,
      isLoading: false,
      refundPaymentOptions: [],
    };
  },
  created() {
    this.fetchallPaymentOptions();
    this.fetchData();
  },
  methods: {
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions",
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.refundPaymentOptions.push({
              value: item.paymentOptionId,
              text: item.name,
            });
            this.isLoading = false;
          });
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    fetchData() {
      this.$store.dispatch("config/getActionPrivilege", "Order-Detail");
      axios
        .get(`Order/api/V1.0/Refund/GetRefundById?Id=${this.$route.params.id}`)
        .then((res) => {
          this.isLoading = false;
          this.refundDetail = res;
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped></style>
